import React, { useState, useRef, useCallback } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { updateSlug, updateCategory, updateImage, updateTitle, updateContent, updateBlogImage } from "../redux/blog/actions";

// Custom TableBlot — Quill ko <table> ko strip karne se rokta hai
const BlockEmbed = Quill.import("blots/block/embed");
class TableBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.innerHTML = value;
    return node;
  }
  static value(node) {
    return node.innerHTML;
  }
}
TableBlot.blotName = "table";
TableBlot.tagName = "table";
Quill.register(TableBlot);

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";


function AdminBlog() {
  const quillRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slug, category, image, title, content, blogImage } = useSelector(state => state.blog);

  const [formerror, setFormError] = useState({});
  const [featureImgError, setFeatureImgError] = useState("");
  const [imageUploadState, setImageUploadState] = useState("");
  const [blogImgErr, setblogImgErr] = useState("");
  const [blogImgState, setBlogImgState] = useState("");


  const handleFileChange = async (event) => {
    setImageUploadState("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setFeatureImgError("Please Upload Image File.");
        setImageUploadState("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, { method: "GET" });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, { method: "PUT", body: selectedFile });
          if (uploadRes.ok) {
            const originalUrl = data.url.split("?")[0];
            setImageUploadState("Image Uploaded!");
            dispatch(updateImage(originalUrl));
          }
        }
      } catch (error) {
        setFeatureImgError(error.message);
        setImageUploadState("");
      }
    }
  };

  const handleBlogImg = async (event) => {
    setBlogImgState("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setblogImgErr("Please Upload Image File.");
        setBlogImgState("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, { method: "GET" });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, { method: "PUT", body: selectedFile });
          if (uploadRes.ok) {
            const originalUrl = data.url.split("?")[0];
            setBlogImgState("Image Uploaded!");
            dispatch(updateBlogImage(originalUrl));
          }
        }
      } catch (error) {
        setblogImgErr(error.message);
        setBlogImgState("");
      }
    }
  };

  // Editor toolbar se image upload
  const imageHandler = useCallback(async () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, { method: "GET" });
        const data = await res.json();
        if (data.url) {
          await fetch(data.url, { method: "PUT", body: file });
          const imageUrl = data.url.split("?")[0];
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection(true);
          quill.insertEmbed(range ? range.index : 0, "image", imageUrl);
          quill.setSelection((range ? range.index : 0) + 1);
        }
      } catch (error) {
        console.error("Image upload failed:", error);
      }
    };
  }, []);

  const validation = () => {
    let err = {};
    if (!title) err.blog_title = "Please Enter Blog Title.";
    else if (title.length <= 30) err.blog_title = "Title should be at least 30 characters.";
    if (!image) err.image = "Please Upload the Image.";
    if (!slug) err.slug = "Please Enter Blog Slug.";
    else if (slug.length <= 10) err.slug = "Slug should be at least 10 characters";
    if (!content) err.blogcontent = "Please Enter Blog content.";
    else if (content.length <= 200) err.blogcontent = "Blog Content should be at least 200 characters";
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleProceed = () => {
    if (validation()) navigate('/preview');
  };

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["link", "image", "video"],
        ["clean"],
      ],
      handlers: { image: imageHandler },
    },
    clipboard: { matchVisual: false },
  };

  const formats = [
    "header", "font", "size", "bold", "italic", "underline", "strike",
    "blockquote", "list", "bullet", "indent", "link", "image", "video",
    "align", "color", "background", "code-block", "table",
  ];

  return (
    <div className="container">
      <h3 className="fw-bold" style={{ marginBottom: "24px", color: "#1e3a8a", letterSpacing: "-0.5px" }}>
        Create Blog Post
      </h3>

      {/* Blog Title */}
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Blog Title</label>
        <input type="text" className="form-control shadow-sm" placeholder="Enter blog title..."
          onChange={(e) => dispatch(updateTitle(e.target.value))} value={title}
          style={{ borderRadius: "6px", borderColor: "#d0d5dd", padding: "0.65rem 0.85rem" }} />
        <span className="text-danger small">{formerror.blog_title}</span>
      </div>

      {/* Feature Image */}
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Feature Image</label>
        <input type="file" className="form-control shadow-sm" onChange={handleFileChange}
          style={{ borderRadius: "6px", padding: "0.65rem 0.85rem", borderColor: "#d0d5dd" }} />
        <span className="text-danger small">{formerror.image}<br />{featureImgError}</span>
        {image ? (
          <div className="mt-3">
            <label className="fw-semibold">Preview:</label>
            <img src={image} alt="Uploaded" style={{ width: "100%", maxWidth: "450px", borderRadius: "10px", marginTop: "6px" }} />
          </div>
        ) : <div className="text-muted">{imageUploadState}</div>}
      </div>

      {/* Category */}
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Category</label>
        <select className="form-select shadow-sm" onChange={(e) => dispatch(updateCategory(e.target.value))} value={category}
          style={{ borderRadius: "6px", borderColor: "#d0d5dd", padding: "0.65rem 0.85rem" }}>
          <option value="software">Software Development</option>
          <option value="devops">Devops</option>
          <option value="ai-ml">AI/ML</option>
          <option value="iot">IOT</option>
          <option value="ar">AR</option>
        </select>
      </div>

      {/* Slug */}
      <div className="mb-3" style={{ background: "#f0f7ff", padding: "14px", borderRadius: "6px", fontSize: "14px", color: "#1e3a8a" }}>
        <ul className="mb-0 ps-3">
          <li>Slug is the URL Path name for the blog</li>
          <li>Example: https://stellarmind.ai/blog/[slug-name]</li>
          <li>No spaces or uppercase letters — use hyphens (-)</li>
        </ul>
      </div>
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Blog Slug</label>
        <input type="text" className="form-control shadow-sm" placeholder="enter-blog-slug"
          onChange={(e) => dispatch(updateSlug(e.target.value))} value={slug}
          style={{ borderRadius: "6px", borderColor: "#d0d5dd", padding: "0.65rem 0.85rem" }} />
        <span className="text-danger small">{formerror.slug}</span>
      </div>

      <div className="mb-3" style={{ background: "#fff7e6", padding: "14px", borderRadius: "6px", fontSize: "14px", color: "#b45309" }}>
        Use only one H1 tag for SEO optimization.
      </div>

      {/* Content Image Upload */}
      <div className="mb-3" style={{ background: "#f0f7ff", padding: "14px", borderRadius: "6px", fontSize: "14px", color: "#1e3a8a" }}>
        <strong>Images:</strong> Click the 🖼️ image button in the editor toolbar to upload &amp; insert images directly into the blog content.
      </div>
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Upload Image for Blog Content (optional)</label>
        <input type="file" className="form-control shadow-sm" onChange={handleBlogImg}
          style={{ borderRadius: "6px", padding: "0.65rem 0.85rem", borderColor: "#d0d5dd" }} />
        <span className="text-danger small">{blogImgErr}</span>
        {blogImage ? (
          <div className="mt-3">
            <label className="fw-semibold">Preview:</label>
            <img src={blogImage} alt="Uploaded" draggable="true"
              style={{ width: "100%", maxWidth: "450px", borderRadius: "10px", marginTop: "6px" }} />
          </div>
        ) : <div className="text-muted">{blogImgState}</div>}
      </div>

      {/* Table Builder UI — commented out
      <div className="mb-4" style={{ background: "#f0fff4", padding: "16px", borderRadius: "8px", border: "1px solid #bbf7d0" }}>
        <label className="fw-semibold mb-3 d-block" style={{ color: "#166534", fontSize: "15px" }}>
          Insert Table into Blog Content
        </label>

        <div className="d-flex align-items-center gap-3 flex-wrap mb-3">
          <div>
            <label className="small me-1">Rows:</label>
            <input type="number" min="1" max="20" value={tableRows}
              onChange={(e) => setTableRows(Math.max(1, Number(e.target.value)))}
              style={{ width: "65px", borderRadius: "4px", border: "1px solid #d0d5dd", padding: "4px 8px" }} />
          </div>
          <div>
            <label className="small me-1">Columns:</label>
            <input type="number" min="1" max="10" value={tableCols}
              onChange={(e) => setTableCols(Math.max(1, Number(e.target.value)))}
              style={{ width: "65px", borderRadius: "4px", border: "1px solid #d0d5dd", padding: "4px 8px" }} />
          </div>
        </div>

        <div style={{ overflowX: "auto", marginBottom: "12px" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", minWidth: `${tableCols * 120}px` }}>
            <thead>
              <tr>
                {tableHeaders.map((h, ci) => (
                  <th key={ci} style={{ padding: "4px", background: "#166534", border: "1px solid #a7f3d0" }}>
                    <input
                      value={h}
                      onChange={(e) => {
                        const updated = [...tableHeaders];
                        updated[ci] = e.target.value;
                        setTableHeaders(updated);
                      }}
                      placeholder={`Header ${ci + 1}`}
                      style={{ ...cellInput, background: "#dcfce7", fontWeight: "600" }}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, ri) => (
                <tr key={ri}>
                  {row.map((cell, ci) => (
                    <td key={ci} style={{ padding: "4px", border: "1px solid #bbf7d0", background: "#f0fff4" }}>
                      <input
                        value={cell}
                        onChange={(e) => {
                          const updated = tableData.map(r => [...r]);
                          updated[ri][ci] = e.target.value;
                          setTableData(updated);
                        }}
                        placeholder="Cell"
                        style={cellInput}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button type="button" onClick={insertTable}
          style={{ background: "#166534", color: "white", border: "none", borderRadius: "6px", padding: "8px 20px", cursor: "pointer", fontWeight: "600" }}>
          + Insert Table into Editor
        </button>
        <div className="text-muted small mt-2">
          Upar table fill karo, phir "Insert Table into Editor" click karo. Table editor mein add ho jayegi.
        </div>
      </div>
      */}

      {/* Blog Content Editor */}
      <div className="mb-4">
        <label className="fw-semibold mb-2 d-block">Blog Content</label>
        <ReactQuill ref={quillRef} theme="snow" modules={modules} formats={formats}
          onChange={(e) => dispatch(updateContent(e))} value={content}
          style={{ minHeight: "240px", borderRadius: "6px" }} />
        <span className="text-danger small">{formerror.blogcontent}</span>
      </div>

      <button onClick={handleProceed} className="btn btn-primary w-100 fw-semibold"
        style={{ background: "linear-gradient(90deg, #1e3a8a, #2563eb)", color: "white", padding: "14px", borderRadius: "8px", fontSize: "17px", border: "none" }}>
        Proceed
      </button>
    </div>
  );
}

export default AdminBlog;
